import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { PovStrip, Services } from "@/components/landing/Services";
import { Work } from "@/components/landing/Work";
import { About } from "@/components/landing/About";
import { Process } from "@/components/landing/Process";
import { Faq } from "@/components/landing/Faq";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

export default function Home() {
  return (
    <main className="bg-[#F2EDE1] font-body" data-testid="home-page">
      <Header />
      <Hero />
      <PovStrip />
      <Services />
      <Work />
      <About />
      <Process />
      <Faq />
      <Contact />
      <Footer />
    </main>
  );
}
